import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';

const Wrapper = styled.div`
  min-height: 100vh;
  background: #fafafa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
`;

const Box = styled.div`
  width: 100%;
  max-width: 400px;
  background: #fff;
  border-radius: 16px;
  padding: 40px 20px 32px 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

const Title = styled.h1`
  font-size: 1.6rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 32px;
  line-height: 1.4;
`;

const Input = styled.input`
  width: 100%;
  padding: 14px 12px;
  border: 1px solid #eee;
  border-radius: 8px;
  font-size: 1rem;
  margin-bottom: 16px;
  background: #fafafa;
`;

const ConfirmButton = styled.button`
  width: 100%;
  padding: 14px 0;
  background: #000;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  margin-top: 8px;
  cursor: pointer;

  &:disabled {
    background: #bdbdbd;
    cursor: not-allowed;
  }
`;

const EmailPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');

  const handleConfirm = () => {
    if (!email) {
      alert('이메일을 입력해주세요.');
      return;
    }

    // TODO: 회원가입 API 호출
    alert('가입을 축하합니다!');
    navigate('/login');
  };

  return (
    <Wrapper>
      <Box>
        <Title>이메일 입력</Title>
        <Input
          type="email"
          placeholder="이메일"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
        <ConfirmButton 
          onClick={handleConfirm}
          disabled={!email}
        >
          확인
        </ConfirmButton>
      </Box>
    </Wrapper>
  );
};

export default EmailPage; 